import { Trees, Coffee, Dog, Waves } from "lucide-react";

const SELOS = [
  { icon: Coffee, texto: "Café da manhã e jantar inclusos" },
  { icon: Dog, texto: "Pet friendly" },
  { icon: Waves, texto: "Piscinas e lago privativo" },
  { icon: Trees, texto: "Natureza e descanso" },
];

export const Hero = () => (
  <section id="inicio" className="relative min-h-[92vh] flex items-center overflow-hidden" data-testid="hero-section">
    <img
      src="/fotos/lago/01.webp"
      alt="Cabanas de frente para o lago na Vila Gramado"
      className="absolute inset-0 w-full h-full object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-r from-[#1b4332]/90 via-[#1b4332]/60 to-[#1b4332]/25" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-28 w-full">
      <div className="max-w-2xl">
        <img
          src="/logo.jpg"
          alt="Selo Vila Gramado"
          className="h-28 w-28 rounded-full object-cover ring-4 ring-[#d4a373]/70 mb-8 fade-up"
        />
        <p className="text-[#d4a373] text-xs uppercase tracking-[0.3em] font-bold mb-4 fade-up" style={{ animationDelay: "0.1s" }}>
          Várzea Grande · Gramado · RS
        </p>
        <h1
          className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#faf7f2] leading-tight fade-up"
          style={{ animationDelay: "0.2s" }}
        >
          Descanso e natureza em cabanas à beira do lago
        </h1>
        <p className="mt-6 text-base md:text-lg text-[#f5f0eb]/85 leading-relaxed fade-up" style={{ animationDelay: "0.3s" }}>
          Chalés aconchegantes com lareira, piscina e café da manhã e jantar inclusos.
          Viva a experiência da serra gaúcha em meio à mata e ao lago.
        </p>
        <div className="mt-10 flex flex-wrap gap-4 fade-up" style={{ animationDelay: "0.4s" }}>
          <a
            href="#acomodacoes"
            data-testid="hero-cta-button"
            className="inline-flex items-center gap-2 bg-[#b85d39] hover:bg-[#9d4e2f] text-white font-bold px-8 py-4 rounded-full text-base transition-all duration-300 hover:-translate-y-0.5 shadow-xl"
          >
            Reserve sua cabana
          </a>
          <a
            href="#decoracao"
            data-testid="hero-decor-button"
            className="inline-flex items-center gap-2 border-2 border-[#f5f0eb]/60 text-[#f5f0eb] hover:bg-[#f5f0eb]/10 font-bold px-8 py-4 rounded-full text-base transition-colors duration-300"
          >
            Decoração romântica
          </a>
        </div>
        <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-4 fade-up" style={{ animationDelay: "0.55s" }}>
          {SELOS.map(({ icon: Icon, texto }) => (
            <div
              key={texto}
              className="flex flex-col items-start gap-2 bg-[#faf7f2]/10 backdrop-blur-sm rounded-xl p-4 border border-[#faf7f2]/15"
            >
              <Icon className="h-5 w-5 text-[#d4a373]" />
              <span className="text-[#f5f0eb]/90 text-xs font-bold leading-snug">{texto}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
